import { Modal, notification } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent, reactive } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import { has } from "../../../../utils/menu-context";
import { createManageExportCsv, createPage, createRowActionReStatus, createRowActionView } from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { createConditionAction } from "./mgt.condition";
import { createColumns } from "./mgt.section";
import { openModalForm as openModalFormConfirmRequest } from "./modal/confirm-request.logic";
import { openModalForm as openModalFormConfirmWaitApproveCenter } from "./modal/confirm-wait-approve-center.logic";
import { openModalForm as openModalFormConfirmWaitDocCustoms } from "./modal/confirm-wait-doc-customs.logic";
import { openModalForm as openModalFormConfirmWaitReceiveCustoms } from "./modal/confirm-wait-receive-customs.logic";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/user";
export const actionPrefix2 = "resource/v1/transaction/userRequest";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callRequestWaitReceiveCustoms = ({ id }) => store.dispatch(`${actionPrefix2}/requestWaitReceiveCustoms`, { id });
export const callRequestReEdit = ({ id }) => store.dispatch(`${actionPrefix2}/requestReEdit`, { id });
export const callRequestNotReceiveCustoms = ({ id }) => store.dispatch(`${actionPrefix2}/requestNotReceiveCustoms`, { id });
export const callRequestWaitApproveCenter = ({ id }) => store.dispatch(`${actionPrefix2}/requestWaitApproveCenter`, { id });
export const callRequestNotReceiveCenter = ({ id }) => store.dispatch(`${actionPrefix2}/requestNotReceiveCenter`, { id });
export const callRequestWaitDocCustoms = ({ id }) => store.dispatch(`${actionPrefix2}/requestWaitDocCustoms`, { id });
export const callRequestApprove = ({ id }) => store.dispatch(`${actionPrefix2}/requestApprove`, { id });
export const callRequestNotApprove = ({ id }) => store.dispatch(`${actionPrefix2}/requestNotApprove`, { id });
export const callRequestCancel = ({ id }) => store.dispatch(`${actionPrefix2}/requestCancel`, { id });
export const callReStatus = ({ data }) => store.dispatch(`${actionPrefix2}/reStatus`, { data });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    const whereCompanyNameThIndex = where.findIndex(d => d.name === "companyNameTh");
    if (whereCompanyNameThIndex !== -1) {
        customWhere.splice(
            whereCompanyNameThIndex,
            1,
            ...[
                { ...where[whereCompanyNameThIndex], openBucket: true },
                { ...where[whereCompanyNameThIndex], logic: "OR", name: "fullNameTh" },
                { ...where[whereCompanyNameThIndex], closeBucket: true, logic: "OR", name: "idCard" }
            ]
        );
    }
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickRequest = ({ props, callRequest }) => {
    setIsLoadingApp(true);
    return callRequest()
        .then(() => onSearch({ props, page: state.page }))
        .then(() => notification["success"]({ message: i18n.global.t("components.operation.success") }))
        .finally(() => setIsLoadingApp(false));
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    if (has({ menuContext, key: "forRequest" })) {
        whereGroup.push([{ name: "username", type: "String", operator: "=", value: userInfo.username }]);
    }
    if (has({ menuContext, key: "forCustoms" }) && !has({ menuContext, key: "forCenter" })) {
        whereGroup.push([
            {
                type: "Subquery",
                operator: "!exists",
                value: JSON.stringify({
                    clazz: "UserRequest",
                    where: [
                        { name: "refOwner.id", type: "GetpathParent", operator: "=", value: "id" },
                        { name: "refStatus.key", type: "String", operator: "=", value: "draft" }
                    ]
                })
            },
            { name: "refDepartmentRegister.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id }
        ]);
    }
    if (has({ menuContext, key: "forCenter" })) {
        whereGroup.push([
            {
                type: "Subquery",
                operator: "!exists",
                value: JSON.stringify({
                    clazz: "UserRequest",
                    where: [
                        { name: "refOwner.id", type: "GetpathParent", operator: "=", value: "id" },
                        { name: "refStatus.key", type: "String", operator: "=", value: "draft" }
                    ]
                })
            }
        ]);
    }
    return [
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "isCeo", type: "Boolean", operator: "=", value: true },
        ...flatWhereGroup({ where: whereGroup, logic: "OR" })
    ];
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [createManageExportCsv({ menuContext })];
    state.manageExtras = [];
    state.rowActions = [
        createRowActionView({
            menuContext,
            onClick: ({ record }) =>
                router.push({ name: `${routerPrefix}-tab`, params: { companyId: record.id, personType: record.refPersonType.key } }),
            visible: () => true
        }),
        {
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="arrow-right.svg"></CIcon> },
            text: () => i18n.global.t("button.sendRequest"),
            showText: () => false,
            visible: ({ record }) => state.conditionAction.canWaitReceiveCustoms({ props, record }),
            onClick: ({ record }) => {
                openModalFormConfirmRequest({
                    onOk: () => onClickRequest({ props, callRequest: () => callRequestWaitReceiveCustoms({ id: record.id }) })
                });
            }
        },
        {
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="arrow-right.svg"></CIcon> },
            text: () => i18n.global.t("button.sendRequest"),
            showText: () => false,
            visible: ({ record }) => state.conditionAction.canWaitApproveCenter({ props, record }),
            onClick: ({ record }) => {
                openModalFormConfirmWaitReceiveCustoms({
                    onOk: res => {
                        if (res.refStatus.key === "waitApproveCenter") {
                            onClickRequest({ props, callRequest: () => callRequestWaitApproveCenter({ id: record.id }) });
                        } else if (res.refStatus.key === "reEdit") {
                            onClickRequest({ props, callRequest: () => callRequestReEdit({ id: record.id }) });
                        } else {
                            onClickRequest({ props, callRequest: () => callRequestNotApprove({ id: record.id }) });
                        }
                    }
                });
            }
        },
        {
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="arrow-right.svg"></CIcon> },
            text: () => i18n.global.t("button.sendRequest"),
            showText: () => false,
            visible: ({ record }) => state.conditionAction.canWaitDocCustoms({ props, record }),
            onClick: ({ record }) => {
                openModalFormConfirmWaitApproveCenter({
                    onOk: res => {
                        if (res.refStatus.key === "waitDocCustoms") {
                            onClickRequest({ props, callRequest: () => callRequestWaitDocCustoms({ id: record.id }) });
                        } else if (res.refStatus.key === "reEdit") {
                            onClickRequest({ props, callRequest: () => callRequestReEdit({ id: record.id }) });
                        } else {
                            onClickRequest({ props, callRequest: () => callRequestNotApprove({ id: record.id }) });
                        }
                    }
                });
            }
        },
        {
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="arrow-right.svg"></CIcon> },
            text: () => i18n.global.t("button.sendRequest"),
            showText: () => false,
            visible: ({ record }) => state.conditionAction.canApprove({ props, record }),
            onClick: ({ record }) => {
                openModalFormConfirmWaitDocCustoms({
                    onOk: () => {
                        onClickRequest({ props, callRequest: () => callRequestApprove({ id: record.id }) });
                    }
                });
            }
        },
        createRowActionReStatus({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.reStatus") }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        onClickRequest({
                            props,
                            callRequest: () => callReStatus({ data: Object.keys(record.request).flatMap(key => record.request[key][0] || []) })
                        }).then(() => onSearch({ props, page: state.page }));
                    }
                });
            },
            visible: ({ record }) => state.conditionAction.canReStatus({ props, record })
        }),
        {
            bind: { class: "btn-danger", size: "small", icon: () => <CIcon file="cancel.svg"></CIcon> },
            text: () => i18n.global.t("button.cancelRequest"),
            showText: () => false,
            visible: ({ record }) => state.conditionAction.canCancel({ props, record }),
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.cancelRequest") }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        onClickRequest({
                            props,
                            callRequest: () => onClickRequest({ props, callRequest: () => callRequestCancel({ id: record.id }) })
                        }).then(() => onSearch({ props, page: state.page }));
                    }
                });
            }
        }
    ];
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            isDistinct: true,
            select: ["*", "refPersonType.*"],
            sort: [{ name: "lastRequestUpdateDate", type: "DESC" }],
            children: [
                {
                    name: "userOperatorTypes",
                    select: ["*", "refOperatorType.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "userRequestOwners",
                    asName: "request.1",
                    select: ["*", "refRequestType.*", "refRequestDoc.*", "refStatus.*", "refDepartment.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "1" }],
                    sort: [
                        { name: "statusChangeDatetime", type: "DESC" },
                        { name: "refStatus.seq", type: "ASC" }
                    ]
                },
                {
                    name: "userRequestOwners",
                    asName: "request.2",
                    select: ["*", "refRequestType.*", "refRequestDoc.*", "refStatus.*", "refDepartment.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "2" }],
                    sort: [
                        { name: "statusChangeDatetime", type: "DESC" },
                        { name: "refStatus.seq", type: "ASC" }
                    ]
                },
                {
                    name: "userRequestOwners",
                    asName: "request.3",
                    select: ["*", "refRequestType.*", "refRequestDoc.*", "refStatus.*", "refDepartment.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "3" }],
                    sort: [
                        { name: "statusChangeDatetime", type: "DESC" },
                        { name: "refStatus.seq", type: "ASC" }
                    ]
                },
                {
                    name: "userRequestOwners",
                    asName: "request.4",
                    select: ["*", "refRequestType.*", "refRequestDoc.*", "refStatus.*", "refDepartment.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "4" }],
                    sort: [
                        { name: "statusChangeDatetime", type: "DESC" },
                        { name: "refStatus.seq", type: "ASC" }
                    ]
                },
                {
                    name: "userRequestOwners",
                    asName: "request.5",
                    select: ["*", "refRequestType.*", "refRequestDoc.*", "refStatus.*", "refDepartment.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "5" }],
                    sort: [
                        { name: "statusChangeDatetime", type: "DESC" },
                        { name: "refStatus.seq", type: "ASC" }
                    ]
                },
                {
                    name: "userRequestOwners",
                    asName: "request.6",
                    select: ["*", "refRequestType.*", "refRequestDoc.*", "refStatus.*", "refDepartment.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "6" }],
                    sort: [
                        { name: "statusChangeDatetime", type: "DESC" },
                        { name: "refStatus.seq", type: "ASC" }
                    ]
                }
            ]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
